module.exports = __webpack_public_path__ + "media/images/efriends_logo-576b18f802dbfe03b57fb8b71afc9545.png";